import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconNotificationsNone } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { useFreePromotionFulfillment } from './hooks/useFreePromotionFulfillment';
import { FreePromotionFulfillment as FreePromotionFulfillmentReskin } from './index_new';

type Props = {
	onDismiss?: () => void;
};

export const FreePromotionFulfillment: React.FC<Props> = ({ onDismiss }) => {
	const { data } = useFreePromotionFulfillment();
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <FreePromotionFulfillmentReskin onDismiss={onDismiss} />;
	}

	return (
		<Flex
			data-qa="free-promotion-fulfillment-section-message"
			data-testid="free-promotion-fulfillment-section-message"
			p={24}
			sx={{ height: '100%', gap: 16 }}
		>
			<Icon icon={iconNotificationsNone} size={24} color="primary-white" />
			<Flex sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
				<Heading as="h2" size="h4">
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.title"
						replacements={{ numSignatures: data.signaturesLocalized }}
						count={data.signatures}
					/>
				</Heading>
				<Text mt={8}>
					<Translate value="corgi.petition.starter_dashboard.notifications.free_promo_fulfillment.body" />
				</Text>
			</Flex>
		</Flex>
	);
};
